module.exports = __webpack_public_path__ + "assets/images/premium-features/shift-appearance-4b8289.png";